import TravelRequirementsBadge from "../travel/TravelRequirementsBadge";
import React from "react";
import {RoundTripFlightMatch} from "../../models/RoundTripFlightMatch";
import RoundTripFlightInfoBlock from "./RoundTripFlightInfoBlock";

interface Props {
    roundTripFlightMatch: RoundTripFlightMatch;
}

const RoundTripComparisonItem: React.FC<Props> = ({roundTripFlightMatch}) => {
    const {round_trip_flight} = roundTripFlightMatch;
    const {destination_city} = round_trip_flight;
    const hasConnection =
        (round_trip_flight.outbound_flights?.length ?? 0) > 1 ||
        (round_trip_flight.inbound_flights?.length ?? 0) > 1;

    return (
        <div
            className={`flight-result-card flex flex-col items-start justify-between rounded-2xl shadow-card bg-white p-4 sm:pr-6 sm:pl-8 gap-4 xl:gap-8 w-full transition-smooth ${hasConnection ? "xl:flex-row xl:items-center sm:py-5 min-h-[142px]" : "lg:flex-row lg:items-center sm:py-4"}`}>
            {/* Airport Info */}
            <div className="flex min-w-0 shrink-0 flex-col items-start gap-1 text-start lg:max-w-[160px] xl:min-w-[120px] transition-smooth">
                <span
                    className="max-w-full truncate text-base sm:text-lg lg:text-xl font-bold tracking-tight text-[#2D2D2D]"
                    title={destination_city}
                >
                    {destination_city}
                </span>
                <span className="text-sm font-semibold tracking-tight text-[#B08EFE]">Ryanair</span>
            </div>

            <TravelRequirementsBadge requirements={roundTripFlightMatch.travel_requirements} />
            {/* Flight Details */}
            <RoundTripFlightInfoBlock roundTripFlight={round_trip_flight} showShare />
        </div>
    );
};

export default RoundTripComparisonItem;
